import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-background border-t border-white/5 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="space-y-4">
            <h3 className="font-prestige text-2xl text-primary">KRISHNA SUGANDH</h3>
            <p className="text-sm text-muted-foreground font-light leading-relaxed">
              Established in 2007, we are renowned manufacturers and exporters of premium essential oils, attars, and sandalwood products from Kannauj.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm uppercase tracking-widest font-medium">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/products" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Products</Link>
              <Link to="/wholesale" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Wholesale</Link>
              <Link to="/about" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">About Us</Link>
              <Link to="/contact" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Contact</Link>
              <Link to="/track-order" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Track Order</Link>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm uppercase tracking-widest font-medium">Categories</h4>
            <div className="space-y-2">
              <Link to="/products?category=Essential Oils" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Essential Oils</Link>
              <Link to="/products?category=Indian Attars" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Indian Attars</Link>
              <Link to="/products?category=Spice Oils" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Spice Oils</Link>
              <Link to="/products?category=Sandalwood" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Sandalwood Products</Link>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm uppercase tracking-widest font-medium">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin size={16} className="text-primary mt-1 flex-shrink-0" strokeWidth={1.5} />
                <p className="text-sm text-muted-foreground font-light">
                  1568, Mahatma Gandhi Rd, near LIC Building, Ashok Nagar, Kannauj, UP 209725
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-primary flex-shrink-0" strokeWidth={1.5} />
                <a href="tel:+919108279182" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  +91 91082 79182
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-primary flex-shrink-0" strokeWidth={1.5} />
                <a href="mailto:krishnasugandh@outlook.com" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                  krishnasugandh@outlook.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 text-center">
          <p className="text-sm text-muted-foreground font-light">
            © 2026 Krishna Sugandh. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};